/**
 * This schema defines the structure of
 * the user preferences back when they used to be
 * stored in local storage.
 *
 * DO NOT MODIFY THIS SCHEMA unless you know what you're doing.
 * This should remain static
 */

import {z} from 'zod'

const legacyExportPresetSchema = z.object({
  uuid: z.string(),
  name: z.string(),
  cols: z.array(
    z.object({
      name: z.string(),
      sort: z.enum(['ASC', 'DESC']).optional(),
      formatter: z.string().optional(),
      language: z.string().optional(),
    })
  ),
  includeAdvancedParameters: z.boolean().optional(),
})

export const legacyUserPreferencesSchema = z
  .object({
    version: z.number(),
    exports: z
      .object({
        transaction: z.object({
          presets: z.array(legacyExportPresetSchema),
        }),
        subscription: z.object({
          presets: z.array(legacyExportPresetSchema),
        }),
        payout: z.object({
          presets: z.array(legacyExportPresetSchema),
        }),
        payment_agreement: z.object({
          presets: z.array(legacyExportPresetSchema),
        }),
      })
      .partial(),
  })
  .partial()

export type LegacyUserPreferences = z.infer<typeof legacyUserPreferencesSchema>
